import { modalClasses } from '@mui/material/Modal';
import type { SidebarSide } from './useSidebarLayout';

/** Ids of the two side hosts, which the header toggles name as the sheets they control. */
export const SHEET_ID = {
  left: 'investigation-left-sheet',
  right: 'investigation-right-sheet',
} as const;

const SIDES: readonly SidebarSide[] = ['left', 'right'];

/**
 * A modal layer is showing: a dialog, menu or popover, wherever in the React tree it was drawn. The sheet's
 * trap and Escape give way to it, as MUI's own nested traps do.
 */
export const otherModalOpen = () => document.querySelector(`.${modalClasses.root}:not(.${modalClasses.hidden})`) !== null;

/** The header toggle that names this side's sheet as the one it controls. */
export const toggleFor = (side: SidebarSide) => document.querySelector<HTMLElement>(`[aria-controls="${SHEET_ID[side]}"]`);

/** The side whose sheet holds this node, if either does. */
export const sideOf = (node: Element): SidebarSide | undefined => SIDES.find((side) => node.closest(`#${SHEET_ID[side]}`));

/** Somewhere focus can usefully go back to: on the page, outside both sheets and not inside an inert part. */
export function canRestoreTo(node: Element | null): node is HTMLElement {
  return node instanceof HTMLElement
    && node.isConnected
    && node !== document.body
    && sideOf(node) === undefined
    && node.closest('[inert]') === null;
}

/**
 * Focus nobody can use: on the body, or inside an inert part. A browser drops focus to the body when a closing
 * dialog hands it back into a closed sheet; jsdom leaves it on the inert node, so both count.
 */
export const stranded = (node: Element | null) => node === null || node === document.body || node.closest('[inert]') !== null;
